import { render, staticRenderFns } from "./PublicEventsContainer.vue?vue&type=template&id=6981890f&scoped=true"
import script from "./PublicEventsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicEventsContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PublicEventsContainer.vue?vue&type=style&index=0&id=6981890f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981890f",
  null
  
)

export default component.exports